import Collect from './collect';

export default Collect;
